export default {
  xmlAudits: [],
  xmlAudit: undefined,
};
